import { render, staticRenderFns } from "./statisticsall.vue?vue&type=template&id=8aafaad8&scoped=true&"
import script from "./statisticsall.vue?vue&type=script&lang=js&"
export * from "./statisticsall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aafaad8",
  null
  
)

export default component.exports